import {useEffect} from 'react';
import {useLocation, useSearchParams} from 'react-router-dom';

export default function ScrollToTop() {
    const {key, pathname, state, search} = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedTab = searchParams.get('tab');
    

    const blacklist = ['companies', 'investment', 'page', '?ca', 'teammember/', 'team/', 'insights'];
    const res = blacklist.map((item) => {
        if (pathname === '/' && search.includes('?ca')) {
            return true;
        }
        if (pathname === '/team/' || pathname === '/team' || pathname === '/teammember/' || pathname === '/teammember') {
            return (pathname?.split("/").length - 1) > 2 || !pathname.includes(state?.from)
        }
        if (item === 'teammember/') {
            // console.log('scrolltopParams', item, pathname, state?.from, selectedTab, selectedTab != null || (pathname.includes(state?.from) || state?.from?.includes(pathname)));
        
            return selectedTab != null || (pathname.includes(state?.from) || state?.from?.includes(pathname))
        }
        if (['/insights/', '/insights'].includes(pathname) && search.includes('?investor')) {
            return true
        }
        return pathname.includes(item);
    });

    useEffect(() => {
        if (!res.includes(true)) {
            window.scrollTo({behavior: 'smooth', top: 0, left: 0});
        }
    }, [key, res]);

    return null;
}
